import {NgModule} from '@angular/core';
import { NgChartsModule } from 'ng2-charts';
import {AuthService} from './auth.service';
import {ModalService} from './modal.service';
import {ProgressService} from './progress.service';
import {ThemesService} from './themes.service';
import {TitleService} from './title.service';
import {TokenStorageService} from './token-storage.service';
import {UserInfoStorageService} from './user-info-storage.service';
import {ProgressOverlayComponent} from './progress-overlay/progress-overlay.component';
import {SharedModule} from '../shared/shared.module';
import {ReconnectionDialogComponent} from './reconnection-dialog/reconnection-dialog.component';
import {UserService} from './user.service';
import {RedirectUserService} from './redirect-user.service';


@NgModule({
    declarations: [
        ProgressOverlayComponent,
        ReconnectionDialogComponent
    ],
    imports: [
        SharedModule,
        NgChartsModule,
    ],
    exports: [
        SharedModule
    ],
    providers: [
        AuthService,
        ModalService,
        ProgressService,
        ThemesService,
        TitleService,
        TokenStorageService,
        UserInfoStorageService,
        UserService,
        RedirectUserService,
    ]
})
export class CoreModule {
}
